export const MIXPANEL_TOKENS = {
  PRODUCTION: '23d3c04aaabf05e456a838bd6a2282a6',
  NON_PRODUCTION: 'f4fa4cfb6a85a087f00030adc2250f3d',
};
